document.addEventListener('DOMContentLoaded', () => {
    // Store the selected selling plan globally
    window.selectedSellingPlan = { id: null, price: null };

    // Save original ATB price 
    let originalAtbPrice = null;
    const atbPriceEl = document.querySelector('#add-to-bag-form .button__price__value');
    if (atbPriceEl) {
        const textNode = Array.from(atbPriceEl.childNodes)
            .find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        originalAtbPrice = textNode ? textNode.textContent.trim() : null;
    }

    customElements.whenDefined('recharge-subscription-widget').then(() => {
        const widget = document.querySelector('recharge-subscription-widget');
        if (!widget || !widget.shadowRoot) return;

        // Reset to original one-time purchase state
        const resetToOneTime = () => {
            window.selectedSellingPlan.id = null;
            window.selectedSellingPlan.price = null;

            if (atbPriceEl && originalAtbPrice !== null) {
                const textNode = Array.from(atbPriceEl.childNodes)
                    .find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
                if (textNode) textNode.textContent = originalAtbPrice;
            }
        };

        // Handle plan selection and update global plan data + ATB price
        const updateGlobalPlan = () => {
            const selectedOption = widget.shadowRoot.querySelector('.rc-purchase-option[rc-selected]');
            if (!selectedOption) return;

            const poRadio = selectedOption.querySelector('input[name="purchaseOption"]');
            if (poRadio && poRadio.value === 'onetime') {
                return resetToOneTime();
            }

            const plansEl = selectedOption.querySelector('rc-selling-plans');
            if (!plansEl || !plansEl.shadowRoot) return;

            const checkedPlan = plansEl.shadowRoot.querySelector('input[name="rc_plan"]:checked');
            if (!checkedPlan) return;

            const sellingPlanId = checkedPlan.value;
            window.selectedSellingPlan.id = sellingPlanId;

            const priceEl = selectedOption.querySelector('.rc-price:not(.strike-through)');
            const rawText = priceEl ? priceEl.textContent.trim() : '';
            const match = rawText.match(/[\d]+[.,]?[\d]*/);
            const priceText = match ? match[0].replace(',', '.') : '';
            window.selectedSellingPlan.price = priceText;

            if (atbPriceEl) {
                const textNode = Array.from(atbPriceEl.childNodes)
                    .find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
                if (textNode) textNode.textContent = priceText;
            }
        };

        // Listen for changes to purchase option or plan selection
        widget.shadowRoot.addEventListener('change', e => {
            if (e.target.name === 'purchaseOption' || e.target.name === 'rc_plan') {
                setTimeout(updateGlobalPlan, 0);
            }
        });

        // Watch for price changes injected by Recharge (fallback)
        const priceObserver = new MutationObserver(updateGlobalPlan);
        const startObserving = () => {
            const sel = widget.shadowRoot.querySelector(
                '.rc-purchase-option[rc-selected] .rc-price:not(.strike-through)'
            );
            if (sel) {
                priceObserver.observe(sel, {
                    childList: true,
                    characterData: true,
                    subtree: true
                });
            }
        };

        // Extra fallback: bind to clicks on plan inputs (even if price doesn't change)
        const bindClickFallback = () => {
            const plansEl = widget.shadowRoot.querySelector('rc-selling-plans')
            if (!plansEl || !plansEl.shadowRoot) return
            const plans = plansEl.shadowRoot.querySelectorAll('input[name="rc_plan"]')
            plans.forEach(plan => {
                plan.addEventListener('click', () => {
                    setTimeout(updateGlobalPlan, 0)
                })
            })
        }

        setTimeout(() => {
            updateGlobalPlan();
            startObserving();
            bindClickFallback();
        }, 500);
    });
});
